export default __webpack_public_path__ + "static/media/420.0ebb002d.jpg";